import axios from './axios'
import generateService from './generator'

function service(endpoint) {
    const base = generateService(endpoint);

    function approve(id, data) {
        return axios.post(`${endpoint}/${id}/approve`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function reject(id, data) {
        return axios.post(`${endpoint}/${id}/reject`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchList: base.fetchList,
        fetchAll: base.fetchAll,
        fetchItem: base.fetchItem,
        approve,
        reject
    }
}

export default service
